import React from 'react';
// Components
import SetupAma from 'components/common/SetupAma/SetupAma';

const SetupContentCreatorAma: React.FC = () => {
  return <SetupAma />;
};

export default SetupContentCreatorAma;
